// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _DYN_DURATION, _DYN_MEASUREMENTS, _DYN_NAME, _DYN_PROPERTIES } from "../../__DynamicConstants";
import { strNotSpecified } from "../../constants/Constants";
import { msToTimeSpan } from "../../utils/HelperFuncs";
import { dataSanitizeId, dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString, dataSanitizeUrl } from "./Common/DataSanitizer";
import { PageViewDataType } from "./DataTypes";
import { PageViewEnvelopeType } from "./EnvelopeTypes";
var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = dataSanitizeId(logger, id);
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _self[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(durationMs);
        }
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant PageViewEnvelopeType instead.
     */
    PageView.envelopeType = PageViewEnvelopeType;
    /**
     * @deprecated Use the constant PageViewDataType instead.
     */
    PageView.dataType = PageViewDataType;
    return PageView;
}());
export { PageView };
//# sourceMappingURL=PageView.js.map